module.exports = {
  REPOSITORY_NAME: [
    'spotifriend-bot-api',
    'dashboard-membership',
    'fe-ybm-brillian',
    'simpeg-be',
    'simpeg-fe',
    'pace-covid-apps',
    'moviedb-frontend',
    'me',
    'go-block',
    'go-restful',
  ],
  JOB: [
    {
      job_title: 'Software Engineer, Frontend',
      job_desc: 'eFishery · Full-time, Working Remotely · Remote',
      job_status: 'Mar 2022 - Present ✅',
      job_skill: [
        'reactjs',
        'nextjs',
        'javascript',
        'graphql',
        'yarn',
        'sentry',
        'go',
        'docker',
      ],
    },
    {
      job_title: 'Frontend Developer',
      job_desc: 'Female Daily Network · Full-time',
      job_status: 'Jan 2020 - Mar 2022',
      job_skill: [
        'reactjs',
        'nextjs',
        'javascript',
        'sentry',
        'redux',
        'antd',
        'lerna',
      ],
    },
    {
      job_title: 'Software Engineer, Frontend',
      job_desc: 'Ralali.com - B2B Marketplace · Full-time',
      job_status: 'Mar 2019 - Dec 2019',
      job_skill: ['reactjs', 'javascript', 'angularjs', 'laravel'],
    },
    {
      job_title: 'Web Developer',
      job_desc: 'DISITU · Contract',
      job_status: 'Sep 2018 - Feb 2019',
      job_skill: ['laravel', 'php', 'css'],
    },
    {
      job_title: 'Information Technology Internship',
      job_desc: 'Lokadata.id · Intern',
      job_status: 'Jan 2018 - Mar 2018',
      job_skill: ['lumen', 'php', 'angularjs', 'javascript'],
    },
    {
      job_title: 'Laboratory Assistant',
      job_desc: 'Institut Teknologi PLN Jakarta',
      job_status: 'Feb 2015 - Feb 2017',
      job_skill: [
        'teaching',
        'learning',
        'management',
        'research & development',
      ],
    },
  ],
}
